module.exports = __webpack_public_path__ + "img/6.6680f064.png";